import { faArrowLeft, faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box } from '@mui/material'
import { TooltipRenderProps } from 'react-joyride'
import { useStyles } from './WalkthroughTooltip.styles'

export const WalkthroughTooltip = ({
  backProps,
  index,
  primaryProps,
  step,
  tooltipProps,
}: TooltipRenderProps) => {
  const { classes } = useStyles()
  return (
    <Box
      {...tooltipProps}
      className={classes.root}
      data-testid={'walkthrough-tooltip'}
    >
      {step.content && (
        <Box data-testid={'walkthrough-content'}>{step.content}</Box>
      )}
      <Box className={classes.footer} data-testid={'walkthrough-footer'}>
        {index > 0 && (
          <div {...backProps} data-testid={'walkthrough-back-btn'}>
            <FontAwesomeIcon
              icon={faArrowLeft}
              style={{
                width: '24px',
                height: '24px',
                color: '#FFFFFF',
                cursor: 'pointer',
              }}
            />
          </div>
        )}
        <div {...primaryProps} data-testid={'walkthrough-next-btn'}>
          <FontAwesomeIcon
            icon={faArrowRight}
            style={{
              width: '24px',
              height: '24px',
              color: '#FFFFFF',
              cursor: 'pointer',
            }}
          />
        </div>
      </Box>
    </Box>
  )
}
